@if (readonly) {
  <sui-input
    class="ag-floating-filter-input"
    [ngModel]="summary"
    [readonly]="true"
    (click)="openPopup()"
  ></sui-input>
} @else {
  <sui-input
    class="ag-floating-filter-input"
    type="number"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
  ></sui-input>
}
